import { render, staticRenderFns } from "./NotFind.vue?vue&type=template&id=aeb416ac"
import script from "./NotFind.vue?vue&type=script&lang=js"
export * from "./NotFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports